
















import '@/icons/yws';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WeatherForecastHour extends Vue {
    @Prop() private date!: Date;
    @Prop() private iconFileName!: string;
    @Prop() private symbolText!: string;
    @Prop() private temperature!: number;
}

